
<generic-error class="mt-48" :buttonValue="errorDetails.buttonValue" :buttonHref="errorDetails.buttonHref">
  {{ errorDetails.body }}
</generic-error>
